module.exports = __webpack_public_path__ + "img/logoCan.59a39711.png";